import _get from "lodash.get";
import URI from "URIjs/URI";
import "URIjs/URI.fragmentQuery";
import { basketFromUriParams } from "site/common/models/basket-url-params.js";

/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone'),
        _ = require('underscore'),
        $ = require('jquery'),
        Mustache = require('mustache'),
        BasketSummaryCollection = require('./basket-summary-collection'),
        BasketSummaryModel = require('./basket-summary-model'),
        BasketModel = require('site/common/models/basket-model'),

        gt = require('common/analytics/google-tagmanager'),
        xhrUris = require('common/xhr-uris'),
        events = require('common/event-aggregator'),
        config = require('common/page-config');

    var eventType = Modernizr.touch ? ($.mobile ? 'tap' : 'touchstart') : 'click';

    var BasketSummaryView = Backbone.View.extend({
        model: new BasketSummaryModel(),

        templates: {
            view: 'basket-summary-template',
            services: 'basket-summary-services-template',
            totals: 'basket-summary-totals-template'
        },

        events: {},

        ui: {},

        processing: false,

        loaded: false,
        toProcess: null,

        initialize: function (options) {
            this.options = options;
            // set the basket model
            this.basketModel = new BasketModel({
                venueId: this.options.venueId || config.venueId
            });

            // Remove any basket parameters from url.
            const uriParamsBasket = basketFromUriParams();
            if (uriParamsBasket.services && uriParamsBasket.services.length > 0) {
              // Basket parameters are present. Remove them.
              URI.fragmentPrefix = '';
              const uri = new URI()
              uri.removeFragment('item');
              uri.removeFragment('employee');
              history.replaceState({}, "", uri.toString());
            }


            this.events['click .main-button'] = 'onCheckoutClick';
            this.events[eventType + ' .remove'] = 'onRemoveSku';
            this.delegateEvents(this.events);

            this.onAddServiceClicked = this.onAddServiceClicked.bind(this);

            // listen to the time selection event and update services pricing, duration and total amount
            this.listenTo(events, events.CHECKOUT_AVAILABILITY_TIME_SELECTED, this.updateData);
            this.listenTo(events, events.CHECKOUT_AVAILABILITY_PRICES, this.updateData);
            this.listenTo(events, events.BASKET_UPDATED, this.loadBasket);

            // update model with view's options
            this.model.set(this.options);

            // set the collection
            this.collection = new BasketSummaryCollection({
                canRemoveSkus: this.model.get('canRemoveSkus')
            });

            const basketValue = this.getBasketPrice();
            if (!this.options.isReschedule) {
            this.options.track.initialPrice(basketValue);
          }

            // Return services update promises and parse them when all are done
            setTimeout(_.bind(function() {
                this.loadBasket(this.options.basket);
            }, this), 10);
        },

        getBasketPrice: function() {
          const skus = this.options.basket.map(item=>item.skus).flat();
          const prices = skus.map(sku=>sku.price);
          return prices.reduce((a,b)=> {return a + b});
        },

        loadBasket: function(basket) {
            var basketLoaded = this.collection.loadBasket(basket);

            $.when.apply(this, basketLoaded).done(_.bind(function () {
                this.loaded = true;
                this.updateSummary();

                if (this.toProcess) {
                    this.updateData(this.toProcess);
                }
            }, this));
        },

        render: function () {
            this.$el.append(Mustache.render($('#' + this.templates.view).html(), {}));

            this.ui = {
                services: this.$el.find('.services'),
                totals: this.$el.find('.totals'),
                loading: this.$el.find('.loading-message'),
                errorMessages: this.$el.find('.error-messages')
            };
        },

        updateSummary: function () {
            var venuePageUri, services, totals;

            // set the venue page uri
            if (config.isMobile) {
                venuePageUri = this.options.venueUri;
            } else {
                venuePageUri = config.venuePageUri;
            }

            // set the services object
            services = {
                services: this.collection.getServices(),
                venuePageUri: this.collection.getServices().length ? venuePageUri : null
            };

            // check if more services can be added
            if (services.venuePageUri && this.model.get('canAddMoreServices')) {
                services.canAddMoreServices = true;
            }

            // set the totals object
            totals = this.collection.getTotals();
            // show loading throbber
            this.ui.loading.show();
            // remove existing list
            this.ui.services.empty();
            // update services section
            this.renderSection('services', services);
            // check if totals section can be shown. if not remove total
            if (!this.model.get('showTotals')) {
                totals.total = null;
            }
            // update totals section
            this.renderSection('totals', totals);

            var addService = $('.add-service', this.$el);
            addService.on('click', this.onAddServiceClicked);

            // update checkout button
            this.toggleCheckoutButton();
            // hide loading
            this.ui.loading.hide();
        },

        toggleCheckoutButton: function () {
            var disableButton = false;

            if (this.model.get('hasTimeSelection')) {
                // check the status of the continue button
                disableButton = this.options.disableContinueButton || typeof this.model.get('time') !== 'number';
            }

            // set the button status.
            // NOTE: if mobile button can not be disabled as there is no time selection
            this.ui.totals.find('.main-button').toggleClass('disabled', !this.model.get('isMobile') && disableButton);

            if (this.model.get('continueButtonLabel')) {
                this.ui.totals.find('.main-button .button-value').text(this.model.get('continueButtonLabel'));
            }
        },

        updateData: function (data) {
            var curService, employee;

            // if there is an error message, close it
            if (this.ui.totals.find('.error-message').length > 1) {
                this.ui.errorMessages.empty();
            }

            if (this.processing) {
                return;
            }

            if (!this.loaded) {
                this.toProcess = data;
                return;
            }

            // update checkout uri on model
            if (data.checkoutUri) {
                this.model.set('checkoutUri', data.checkoutUri);
            }

            // set the employee
            employee = data.employeeId ? data.employeeId : null;
            this.model.set('employeeId', employee);
            this.collection.employeeId = employee;

            // update selected date and time slot
            if (data.time || data.date) {
                this.model.set({
                    date: data.date || this.model.get('date'),
                    time: data.time
                });
            }

            // update services on model
            if (data.services && data.services.length > 0) {
                _.each(data.services, _.bind(function (service) {
                    curService = this.collection.get(service.serviceId);

                    if (!curService) {
                        return;
                    }

                    // check if single service options is enabled
                    curService.set('canRemoveSkus', this.model.get('canRemoveSkus'));

                    // update each sku in the service
                    _.each(curService.get('skus'), _.bind(function (sku) {
                        sku = _.extend(sku, _.findWhere(service.skus, {skuId: sku.choiceId}) || {});
                    }, this));
                }, this));
            } else {
                // no services are being passed. reset prices
                this.collection.each(function (service) {
                    _.each(service.get('skus'), function (sku) {
                        sku.price = null;
                    });
                });
            }

            // update summary section
            if (this.loaded) {
                this.updateSummary();
            }
        },

        updateLocation: function() {
          var uri = new URI('');
          uri.addQuery('date', this.model.get('date'));
          uri.addQuery('time', this.model.get('time'));

          var url = location.pathname + '#' + uri.toString();
          window.sessionStorage.setItem("edit-basket-"+ config.venueId, url);

          window.history.replaceState(null, null, url);
        },

        renderSection: function (section, data) {
            this.ui[section].html(Mustache.render($('#' + this.templates[section]).html(), data));
        },

        onAddServiceClicked: function (event) {
            var category = config.isMobile ? 'basket' : 'availability';
            var view = this;
            this.options.track.addService(category).then(() => {
                view.followExtendedUrl($(event.currentTarget).attr('href'));
            });
        },

        followExtendedUrl: function (href) {
            // get current url
            var hashFragmentsToInclude = ['highlight-name', 'highlight-services'];
            var currentUrl = new URI(document.location.href).fragmentPrefix('');
            var currentUrlFragments = currentUrl.fragment(true);
            var addFragments = _.intersection(_.keys(currentUrlFragments), hashFragmentsToInclude);

            // get link url
            var hrefUrl = new URI(href).fragmentPrefix('');

            // if highlight name is present on the fragments
            if (addFragments.length > 0) {
                _.each(addFragments, function (fragment) {
                    hrefUrl.addFragment(fragment, currentUrlFragments[fragment]);
                });
            }

            window.location =  hrefUrl.toString();
        },

        onCheckoutClick: function (event) {
            var btn = $(event.currentTarget),
                btnLabel = btn.find('.button-value');

            this.checkoutBtnText = btnLabel.text();

            if (this.processing || btn.hasClass('disabled') || btn.hasClass('searching')) {
                return;
            }

            btn.addClass('searching');
            this.continueLabel = btnLabel.text();
            btnLabel.text(config.cms.checkout.total['btn-processing']);
            this.processing = true;

            // if isReschedule submit via ajax request
            if (this.options.isReschedule) {
                this.rescheduleSubmit();
                return;
            }

            // If mobile change page hash
            if (config.isMobile) {
                window.location.hash = '#' + this.mobileCheckout();
                return;
            }
            var basketSummaryView = this;
            this.options.track.checkoutClick().then(() => {
                // redirect the window to the generated uri
                basketSummaryView.updateLocation();
                if (window === window.parent) {
                  window.location = basketSummaryView.generateCheckoutUri();
                } else {
                  this.processing = false;
                  window.open(basketSummaryView.generateCheckoutUri());
                }
            });
        },

        onRemoveSku: function(event) {
            var $remove = $(event.currentTarget);
            var skuId = $remove.parents('.service-skus').data('id');
            var serviceId = $remove.parents('.service').data('id');

            var basket = this.basketModel.getLocalStorage();
            var service = _.find(basket.services, function(service) {return service.serviceId === serviceId;});

            if (service) {
                service.skus = _.filter(service.skus, function(sku) {return sku.choiceId !== skuId;});
                basket.services = _.filter(basket.services, function(service) {return service.skus.length > 0;});

                this.options.track.removeSku(config.isMobile ? 'basket' : 'availability');
            }

            this.basketModel.set('services', basket.services);
            this.basketModel.setLocalStorage();

            events.trigger(events.BASKET_UPDATED, basket.services);
        },

        mobileCheckout: function () {
            var uri,
                fulfillmentType = this.model.get('fulfillmentType'),
                basket = this.basketModel.getLocalStorage().services[0],
                basketService = basket.skus[0];

            if (fulfillmentType === 'DATED') {
                uri = new URI('time-page');
                uri.addQuery('offerId', basket.serviceId);
                uri.addQuery('type', 'dated');

                if (basketService) {
                    if (basketService.roomTypeId) {
                        uri.addQuery('room-type-id', basketService.roomTypeId);
                    }

                    uri.addQuery('guests', basketService.guests);
                }
            } else if (fulfillmentType === 'EVOUCHER') {
                uri = new URI('checkout-page');
                uri.addQuery('offers', this.collection.getUriServices());
            } else {
                uri = new URI('date-time-page');
                uri.addQuery('venueId', this.options.venueId);

                if (this.options.date) {
                  uri.addQuery('date', this.options.date);
                }

                if (this.options.timeFrom) {
                    uri.addQuery('timeFrom', this.options.timeFrom);
                  }
                  if (this.options.timeTo) {
                    uri.addQuery('timeTo', this.options.timeTo);
                  }

                if (config.isMobileAppAndroid) {
                    uri.addQuery('proposedServices', this.collection.getUriServices());
                }
            }

            return uri.toString();
        },

        generateCheckoutUri: function () {
            var uri = new URI(config.baseCheckoutUri);

            uri.addQuery('offers', this.collection.getUriServices());
            uri.addQuery('date', this.model.get('date'));
            uri.addQuery('time', this.model.get('time'));

            return uri.toString();
        },

        rescheduleSubmit: function () {
            this.options.track.confirm();
            var params = {
                    employeeId: this.model.get('employeeId'),
                    date: this.model.get('date'),
                    startTime: this.model.get('time'),
                    rescheduleToken: this.model.get('rescheduleToken')
            };

            $.ajax({
                method: 'POST',
                url: xhrUris.accountReschedule,
                data: params,
                success: _.bind(function (data, textStatus, xhr) {
                    this.options.track.success();
                    // fire success event sending new date/time
                    this.trigger('rescheduleSuccess', {
                        statusCode: xhr.status,
                        params: params
                    });
                }, this),
                error: _.bind(this.handleFailure, this)
            });
        },

        handleFailure: function (xhr, textStatus, error) {
            var errorMessage,
                mainButton = this.ui.totals.find('.main-button'),
                errorNode = $('<div/>').addClass('error-message');

            // enable continue button
            mainButton.removeClass('searching');
            mainButton.find('.button-value').text(this.continueLabel);
            this.processing = false;

            // check which error will be shown and add to tooltip
            if (xhr.status === 400) {
                errorMessage = config.cms.reschedule['unable-messages']['slot-unavailable'];
            } else if (xhr.status === 500) {
                errorMessage = config.cms.reschedule['unable-messages']['general-error'];
            } else {
                errorMessage = config.cms.reschedule['unable-messages']['general-error'];
            }

            errorNode.append($('<span>').text(errorMessage));
            // attach error message and show it
            this.ui.errorMessages.empty().append(errorNode).show();

            const errorReason = _get(
                xhr,
                "responseJSON.jsonException.localizedMessage",
                `${xhr.status} - ${error}`
            );

            this.options.track.failure(errorReason);
        },

        cleanup: function () {
            this.stopListening(events, events.CHECKOUT_AVAILABILITY_TIME_SELECTED, this.updateData);
            this.stopListening(events, events.CHECKOUT_AVAILABILITY_PRICES, this.updateData);
            this.stopListening(events, events.BASKET_UPDATED, this.loadBasket);
            this.$el.off('click');
        }
    });

    return BasketSummaryView;
});
